import React from "react";
import ReactDOM from "react-dom";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import roomList from "./../data/availableRooms.json";

export default function AddRoomComponent({onAddRoom}){
    const el = document.createElement('a');
    document.body.appendChild(el);
    const [opened, setOpened] = React.useState(false);
    function onAddRoomInner(room){
        onAddRoom(room);
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [marginLeft, setMarginLeft] = React.useState(0);

    const handleClick = (event) => {
        setMarginLeft(ReactDOM.findDOMNode(event.currentTarget).clientWidth);
        setAnchorEl(event.currentTarget);
        setOpened(true);
    };

    const handleClose = () => {
        setOpened(false);
    };

    return <div className="addRoomWrapper">
        <div className="header">
            <div className="button" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                <AddCircleIcon />
                <span>Raum hinzufügen</span>
            </div>
            {'parentIFrame' in window
            ? <Menu
                id="simple-menu"
                anchorEl={el}
                keepMounted
                open={true}
                onClose={handleClose}
                style={{marginLeft: (0.8 * marginLeft) + "px", visibility: opened ? 'visible' : 'hidden'}}
            >
                {roomList.map(r => <MenuItem key={r.type} style={{fontSize: "inherit"}} className="addRoomRoomListItem" onClick={event => onAddRoomInner(r)}>{r.name}</MenuItem>)}
            </Menu>
            : <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={opened}
                onClose={handleClose}
                style={{marginLeft: (0.8 * marginLeft) + "px", visibility: opened ? 'visible' : 'hidden'}}
            >
                {roomList.map(r => <MenuItem key={r.type} style={{fontSize: "inherit"}} className="addRoomRoomListItem" onClick={event => onAddRoomInner(r)}>{r.name}</MenuItem>)}
            </Menu>}
        </div>
    </div>
}
